import React from 'react';

import { IconProps } from '@shared/interfaces/icon.interface';

export const VerifiedIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.21 6.655A2.445 2.445 0 016.654 4.21h1.112c.646 0 1.264-.257 1.722-.71l.777-.779a2.445 2.445 0 013.458-.01l.001.001.01.01.778.777c.458.455 1.077.71 1.722.71h1.111a2.445 2.445 0 012.445 2.446v1.11c0 .645.255 1.264.71 1.723l.778.778c.958.952.963 2.5.011 3.458h0l-.01.01-.779.779a2.438 2.438 0 00-.71 1.72v1.113a2.444 2.444 0 01-2.444 2.444H16.232c-.646 0-1.265.256-1.722.71l-.778.778a2.444 2.444 0 01-3.46.01l-.009-.01-.777-.777a2.446 2.446 0 00-1.722-.711h-1.11a2.444 2.444 0 01-2.444-2.444V16.23a2.44 2.44 0 00-.711-1.72l-.777-.779a2.443 2.443 0 01-.012-3.455l.002-.004.01-.01.777-.778a2.444 2.444 0 00.711-1.723V6.655"
      ></path>
      <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12.5l3 2.5 5-5"></path>
    </svg>
  );
};
